export const getAppEnv = () => {
  const env = import.meta.env.MODE;
  if (!env || env === 'test') {
    return 'development';
  }
  return env;
};
